export default function Hero() {
  const stats = [
    { value: '千万级', label: '原创内容' },
    { value: '百万+', label: '活跃用户' },
    { value: '每日更新', label: '海量资源' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(var(--primary-400)) 0.5px, transparent 0.5px), radial-gradient(circle at 80% 20%, oklch(var(--accent-400)) 0.5px, transparent 0.5px)',
          backgroundSize: '60px 60px, 80px 80px',
        }}
      />

      <div className="relative w-full px-4 md:px-6 lg:px-8 pt-24 md:pt-28 pb-12 md:pb-16">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 border border-primary-200/60 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              <span className="text-xs font-medium text-primary-700">海角社区 · 千万原创</span>
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              海角网 - 千万原创内容社区平台
            </h1>

            <p className="mt-3 text-lg md:text-xl text-primary-600 font-handwriting">
              发现原创，连接同好，一站畅享海量精彩
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] lg:max-w-none">
              海角网是国内领先的原创内容聚合平台，汇聚海角视频、社区讨论、论坛互动于一体。
              每日更新海量优质原创作品，覆盖多元兴趣领域，为用户提供最新鲜的内容发现体验。
              无论你是创作者还是观众，都能在这里找到属于自己的精彩天地。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                立即探索
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-full border border-background-300/60 hover:bg-background-200 hover:text-foreground-900 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解社区
                <i className="ri-information-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20digital%20community%20hub%20scene%20with%20floating%20content%20cards%20displaying%20artwork%20and%20videos%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20abstract%20geometric%20shapes%20representing%20connection%20and%20creativity%2C%20modern%20clean%20aesthetic%20with%20gentle%20lighting%2C%20editorial%20illustration%20style%2C%20warm%20atmosphere%2C%20organized%20layout%20with%20subtle%20depth&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="海角网原创内容社区平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}